import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMembersTermEndSkillEvaluationTermsIndexType } from "~/domains";

export type ApiMembersTermEndSkillEvaluationTermsIndexParamsType = {
  titleKeyword?: string;
  employeeRoleId?: number;
  fromDate?: string;
  toDate?: string;
};

type RequestDataType = {
  params?: ApiMembersTermEndSkillEvaluationTermsIndexParamsType;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApiMembersTermEndSkillEvaluationTermsIndexType> => {
  const response =
    await new ApiClient().get<ApiMembersTermEndSkillEvaluationTermsIndexType>(
      "/api/members/term_end_skill_evaluation_terms",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiMembersTermEndSkillEvaluationTermsIndexParamsType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisMembersTermEndSkillEvaluationTermsIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiMembersTermEndSkillEvaluationTermsIndexType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisMembersTermEndSkillEvaluationTermsIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
